import { OpenIdConnectConfiguration } from "aurelia-open-id-connect";
import { UserManagerSettings, WebStorageStateStore } from "oidc-client";
import { fs } from "Config/FsConfig";

export default class OidcConfig {
  static get Config(): OpenIdConnectConfiguration {
    return window['_oidc-config'];
  }
  static set Config(config: OpenIdConnectConfiguration) {
    window['_oidc-config'] = config;
  }

  static async InitConfig() {

    const oidcConfigFile = require('Config/open-id-connect-configuration.json');
    var oidcResponse = await fetch(oidcConfigFile.default);
    var oidcResult = await oidcResponse.json();
    console.log('JSON loaded via fetch', oidcResult.OpenIdConnectConfiguration);

    var userStore = oidcResult.OpenIdConnectConfiguration.userManagerSettings.userStore;
    if (userStore.type == "WebStorageStateStore") {
      var storage = new WebStorageStateStore(
        {
          prefix: userStore.prefix,
          store: eval(userStore.store)
        });
      oidcResult.OpenIdConnectConfiguration.userManagerSettings.userStore = storage;
    }

    this.Config = $.extend(oidcResult.Config, oidcResult.OpenIdConnectConfiguration);
  }
}
